export default "__VITE_ASSET__EN40CX4o__"